import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./index.scss";

const Badge = ({ number, color, size, style }) => {
  const badgeStyle = {};
  let styleClass = "";
  switch (style) {
    case "contained":
      styleClass = "-contained";
      break;
    case "inverted":
      styleClass = "-inverted";
      break;
    case "outlined":
      styleClass = "-outlined";
      break;
    case "ghost":
      styleClass = "-ghost";
      break;
    default:
  }
  // Color
  let colorClass;
  switch (color) {
    case "green":
      colorClass = "-green";
      break;
    case "black":
      colorClass = "-black";
      break;
    default:
  }
  // Size
  let sizeClass;
  switch (size) {
    case "small":
      sizeClass = "-small";
      break;
    case "medium":
      sizeClass = "-medium";
      break;
    case "large":
      sizeClass = "-large";
      break;
    default:
  }
  return (
    <div
      style={badgeStyle}
      className={cx("badge-container", {
        [`${colorClass}`]: true,
        [`${sizeClass}`]: true,
        [`${styleClass}`]: true,
      })}
    >
      <p className="number">{number}</p>
    </div>
  );
};

Badge.propTypes = {
  number: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string,
};

Badge.defaultProps = {
  color: "black",
  size: "medium",
  style: "solid",
};

export default Badge;
